<template >
  <div
      v-display-history="{values: inputObj.val, options: inputObj.templates.options, $t: $t, limit: inputObj.templates.display.limit}"
  ></div>

</template>

<script>
import multiselect  from 'vue-multiselect'
export default {
  name: "HistoryInput2",
  components: {
    multiselect,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},
      selectModel: null,
      options:[],
      optionsArr:[],
    }
  },
  mounted() {

  },
  methods: {

  },

  watch: {
    inputModel: {
      handler(newVal) {
        //this.$emit('update:modelValue', JSON.stringify(newVal))
        this.$emit('update:modelValue', newVal)
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
